import { render, staticRenderFns } from "./filter-list.vue?vue&type=template&id=878bd65a"
import script from "./filter-list.vue?vue&type=script&lang=js"
export * from "./filter-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterSelect: require('/var/www/components/filter/Select.vue').default})
